import React, {useState} from 'react';
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import {makeStyles} from '@mui/styles';
import {Box} from "@mui/material";
import {useGroup} from "../contexts/GroupContext";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import TextField from "@mui/material/TextField";
import DialogActions from "@mui/material/DialogActions";
import {firestore} from "../firebase";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    paper: {
        marginRight: theme.spacing(2),
    },
}));

export default function MenuListComposition(props) {
    const classes = useStyles();
    const {sendUserInput, group} = useGroup()

    const [open, setOpen] = React.useState(false);
    const [openDisplayMessage, setOpenDisplayMessage] = React.useState(false);
    const [openSayMessage, setOpenSayMessage] = React.useState(false);
    const [openPlayVideo, setOpenPlayVideo] = React.useState(false);
    const [openDeleteLocation, setOpenDeleteLocation] = useState(false)
    const [locationToDelete, setLocationToDelete] = useState("")
    const anchorRef = React.useRef(null);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleGoTo = (event) => {
        if (props.name.startsWith("homebase")) {
                sendUserInput("go to homebase")
        } else {
            sendUserInput("go to " + props.name)
        }
        handleClose(event)
    }

    const handleDisplayMessage = (event) => {
        setOpenDisplayMessage(true)
        handleClose(event)
    }

    const handleSayMessage = (event) => {
        setOpenSayMessage(true)
        handleClose(event)
    }

    const handlePlayVideo = (event) => {
        setOpenPlayVideo(true)
        handleClose(event)
    }

    const handleDeleteLocation = (event) => {
        setLocationToDelete(event.target.id);
        setOpenDeleteLocation(true)
        handleClose(event)
    }

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        }
    }

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, [open]);


    function handleCloseDisplayMessage() {
        setOpenDisplayMessage(false)
    }

    function handleSubmitDisplayMessage() {
        const message = document.getElementById('displayMessageField').value;
        let locName = "";
        if (props.name.startsWith("homebase")) {
                locName = "homebase"
        } else {
            locName = props.name
        }
        if (/\S/.test(message)) {
//            sendUserInput(`go to ${props.name} and display message ${message}`)
            sendUserInput(`go to ${locName} and display message ${message}`)
        } else {
            alert("Please input a message for the display command before sending!");
        }
        setOpenDisplayMessage(false)
    }

    function handleCloseSayMessage() {
        setOpenSayMessage(false)
    }

    function handleSubmitSayMessage() {
        const message = document.getElementById('sayMessageField').value;
        let locName = "";
        if (props.name.startsWith("homebase")) {
                locName = "homebase"
        } else {
            locName = props.name
        }
        if (/\S/.test(message)) {
//            sendUserInput(`go to ${props.name} and say message ${message}`)
            sendUserInput(`go to ${locName} and say message ${message}`)
        } else {
            alert("Please input a message for the say command before sending!");
        }
        setOpenSayMessage(false)
    }

    function handleClosePlayVideo() {
        setOpenPlayVideo(false)
    }

    function handleSubmitPlayVideo() {
        const vid = document.getElementById('playVideoField').innerText;
        let locName = "";
        if (props.name.startsWith("homebase")) {
                locName = "homebase"
        } else {
            locName = props.name
        }
        //TODO: Will: I have no idea why this empty value passes the regex when it shouldn't - adding this extra case for now
        if (vid !== `​` && /\S/.test(vid)) {
//            sendUserInput(`go to ${props.name}`)
            sendUserInput(`go to ${locName} and play video ${vid}`)
//            sendUserInput(`play video ${vid}`)
        } else {
            alert("Please select a video for the play video command before sending!");
        }
        setOpenPlayVideo(false)
    }

    const handleDeleteLocationSubmit = () => {
        firestore.collection(`groups/${group}/navigation`).doc(locationToDelete).delete()
        handleCloseDeleteLocation()
    };

    function handleCloseDeleteLocation() {
        setOpenDeleteLocation(false)
    }

    return (
        <Box className={classes.root}>
            <Button
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                color="primary"
                variant="contained"
                onClick={handleToggle}
            >
                {props.name}
            </Button>
            <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition>
                {({TransitionProps, placement}) => (
                    <Grow
                        {...TransitionProps}
                        style={{transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'}}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                                    <MenuItem color={'secondary'} onClick={handleGoTo}>Go to {props.name}</MenuItem>
                                    <MenuItem color={'secondary'} onClick={handleDisplayMessage}>Display Message at {props.name}</MenuItem>
                                    <MenuItem color={'secondary'} onClick={handleSayMessage}>Say Message at {props.name}</MenuItem>
                                    <MenuItem color={'secondary'} onClick={handlePlayVideo}>Play Video at {props.name}</MenuItem>
                                    <MenuItem color={'secondary'} id={props.name} onClick={handleDeleteLocation}>Delete location {props.name}</MenuItem>
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
            <Dialog
                open={openDisplayMessage}
                onClose={handleCloseDisplayMessage}
            >
                <DialogContent>
                    <DialogContentText>
                        Please enter a message to display at location {props.name}
                    </DialogContentText>
                    <TextField autoFocus id="displayMessageField" label="Message..." fullWidth/>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDisplayMessage} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleSubmitDisplayMessage} color="primary">
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openSayMessage}
                onClose={handleCloseSayMessage}
            >
                <DialogContent>
                    <DialogContentText>
                        Please enter a message to say at location {props.name}
                    </DialogContentText>
                    <TextField autoFocus id="sayMessageField" label="Message..." fullWidth/>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseSayMessage} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleSubmitSayMessage} color="primary">
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openPlayVideo}
                onClose={handleClosePlayVideo}
            >
                <DialogContent>
                    <DialogContentText>
                        Please pick a video to play at location {props.name}
                    </DialogContentText>
                    <TextField autoFocus select id="playVideoField" label="Name..." fullWidth>
                        {props.videos.map((option) => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </TextField>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClosePlayVideo} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleSubmitPlayVideo} color="primary">
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openDeleteLocation}
                onClose={handleCloseDeleteLocation}
            >
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete {locationToDelete}?
                        You will need to move Zeeno back to that location to save it again!
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDeleteLocation} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDeleteLocationSubmit} color="primary">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}
